import React from 'react';
import { Link } from 'react-router-dom';
import hash from 'object-hash';
import { FormattedMessage } from 'react-intl';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import PropTypes from 'prop-types';

import { transactionsShape } from 'constants/propTypes';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { Cell, TableRow, Table, TableHeader } from 'components/ui/StyledTable';
import { paymentMethodTranslation } from 'constants/payment';

const ORIGINAL_DATE_FORMAT = 'DD MM YYYY';
const DATE_FORMAT = 'DD-MM-YYYY HH:mm';
const DISPLAY_DATE_FORMAT = 'Do MMMM YYYY HH:mm';
const DISPLAY_FIRST_DATE_FORMAT = 'ddd, DD MMM YYYY';
const DISPLAY_TIMEZONE_FORMAT = 'YYYY-MM-DDTHH:mm:ss+0100';

const TransactionDetails = ({ transactions, isFreeTransaction = false }) => (
  <>
    <Table data-testid="transaction-details" data-cy="transaction-details">
      <TableHeader columns={isFreeTransaction ? 15 : 18}>
        <Cell span={3}>
          <FormattedMessage id="transactionDetails.pnr" />
        </Cell>
        {!isFreeTransaction && (
          <Cell span={3}>
            <FormattedMessage id="shifts.transactionDateAndTime" />
          </Cell>
        )}
        <Cell span={3}>
          <FormattedMessage id="transactionDetails.departureDate" />
        </Cell>
        <Cell span={3}>
          <FormattedMessage id="transactionDetails.route" />
        </Cell>
        <Cell span={3}>
          <FormattedMessage id="transactionDetails.amount" />
        </Cell>
        <Cell span={3}>
          <FormattedMessage id="transactionDetails.method" />
        </Cell>
      </TableHeader>

      {transactions
        .filter(({ display }) => display)
        ?.sort((a, b) => moment(`${a.date} ${a.time}`, DATE_FORMAT) - moment(`${b.date} ${b.time}`, DATE_FORMAT))
        ?.map((t, index) => (
          <TableRow columns={isFreeTransaction ? 15 : 18} key={hash(t)} data-testid={`payment-content_${index}`} data-cy="payment-content">
            <Cell alignItems="center" span={3} data-cy="cell" data-testid={`cell-pnr_${index}`}>
              <Link data-testid={`cell-pnr-link_${index}`} to={`/manage/bookings/${t.pnr}/journeys`}>
                {t.pnr}
              </Link>
            </Cell>
            {!isFreeTransaction && (
              <Cell alignItems="center" span={3} data-cy="cell" data-testid={`cell-transactionDate_${index}`}>
                {moment(moment(`${t.date} ${t.time}`, DATE_FORMAT).format(DISPLAY_TIMEZONE_FORMAT)).format(DISPLAY_DATE_FORMAT)}
              </Cell>
            )}
            <Cell alignItems="center" span={3} data-cy="cell" data-testid={`cell-date_${index}`}>
              {t.firstDate ? <span>{moment(t.firstDate, ORIGINAL_DATE_FORMAT).format(DISPLAY_FIRST_DATE_FORMAT)}</span> : <span>-</span>}
            </Cell>
            <Cell alignItems="center" span={3} data-cy="cell" data-testid={`cell-route_${index}`}>
              {t.firstDepartureStationName ? (
                <span
                  data-for="transaction-details-tooltip"
                  data-tip={`${t.firstDepartureStationName} - ${t.firstArrivalStationName}`}
                  data-testid={`transaction-details-tooltip_${index}`}
                >
                  {t.firstDepartureStationShortCode} - {t.firstArrivalStationShortCode}
                </span>
              ) : (
                <span>-</span>
              )}
            </Cell>
            <Cell alignItems="center" span={3} data-cy="cell" data-testid={`cell-amount_${index}`}>
              {t.currency ? <FormattedCurrency amount={t.amount || 0} currency={t.currency} /> : <span>-</span>}
            </Cell>
            <Cell alignItems="center" span={3} data-cy="cell" data-testid={`cell-method_${index}`}>
              {paymentMethodTranslation[t.method] ? <FormattedMessage id={paymentMethodTranslation[t.method]} /> : t.method}
            </Cell>
          </TableRow>
        ))}
    </Table>
    <ReactTooltip id="transaction-details-tooltip" data-testid="transaction-details-tooltip" data-cy="transaction-details-tooltip" />
  </>
);

TransactionDetails.propTypes = {
  transactions: transactionsShape,
  isFreeTransaction: PropTypes.bool
};

export default TransactionDetails;
